import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CourseStateFacade } from './course-state.facade';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "./course-state.facade";
export let DeselectSceneResolver = /*#__PURE__*/(() => {
  class DeselectSceneResolver {
    constructor(store, facade) {
      this.store = store;
      this.facade = facade;
    }
    resolve(route) {
      return this.facade.clearSelectedScene().pipe(switchMap(() => {
        return of(null);
      }));
    }
    static {
      this.ɵfac = function DeselectSceneResolver_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeselectSceneResolver)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.CourseStateFacade));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: DeselectSceneResolver,
        factory: DeselectSceneResolver.ɵfac
      });
    }
  }
  return DeselectSceneResolver;
})();